/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderCredentialV2State
 */
export interface ProviderCredentialV2State {
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2State
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2State
     */
    disabled?: boolean;
}

export function ProviderCredentialV2StateFromJSON(json: any): ProviderCredentialV2State {
    return ProviderCredentialV2StateFromJSONTyped(json, false);
}

export function ProviderCredentialV2StateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2State {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function ProviderCredentialV2StateToJSON(value?: ProviderCredentialV2State | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


